import React, { useEffect, useState } from 'react'
import { MP_PK_SANDBOX as MP_PK } from '../../services/constantes'
import { Payment, usePaymentBrick, StatusScreen, initMercadoPago } from '@mercadopago/sdk-react';
import { Button, Flex } from 'antd';
import { useToasts } from 'react-toast-notifications';



export const PaymentStatusCtrl = (props) => {

  

    useEffect(() => {
        initMercadoPago(MP_PK, { locale: 'pt-BR' });
    }, [])


    async function onSubmit({ selectedPaymentMethod, formData }) {
        //   console.log(selectedPaymentMethod, formData)
    }

    async function onError(error) {
        console.log(error.message)
    };
    async function onReady() {
        //  setLoadingPayment(false)
    };



    return <Flex vertical>

        <StatusScreen
            initialization={{
                paymentId: props.id
            }}
            customization={{
                hideTransactionDate: true
            }}
            onReady={onReady}
            onError={onError}
        />


    </Flex>
}

export default PaymentStatusCtrl
